import { useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../components/img/logo.jpeg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Email required",
        text: "Please enter your email to reset password.",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${baseurl}forgotPassword`, { email });

      Swal.fire({
        icon: "success",
        title: "Reset Link Sent",
        text: response.data.message || "Check your inbox for password reset instructions.",
      });

      setEmail(""); // clear input
    } catch (error) {
      console.error("Forgot password error:", error.response?.data?.message || error.message);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error.response?.data?.message || "Unable to process request. Try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <div>
          <div className="text-center">
            <img src={logo} className="img-fluid logo" alt="Bosplan Logo" />
          </div>

          <div className="mb-3 text-center">
            <h3 className="text-dark">Forgot Password?</h3>
            <p className="text-muted">Enter your email to reset your password</p>
          </div>

          <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
            <form onSubmit={handleSubmit}>
              <div className="mb-3 text-start">
                <label htmlFor="email" className="form-label">
                  Email Address <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mt-3">
                {loading ? (
                  <div className="spinner-container text-center">
                    <div className="spinner-border text-primary" role="status"></div>
                  </div>
                ) : (
                  <button type="submit" className="btn submitbtnn w-100">
                    Send Reset Link
                  </button>
                )}
              </div>

              <p className="mt-3 text-center">
                <span>Remembered your password?</span>{" "}
                <Link to="/" className="text-primary">
                  Back to Login
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
